// extracted by mini-css-extract-plugin
export default {"groupItemsHeaderOverflow":"ItemGroupDetailsPage_groupItemsHeaderOverflow__qbxGY","groupItemsHeaderButton":"ItemGroupDetailsPage_groupItemsHeaderButton__AL1jm"};